import { combine, sample } from 'effector';
import { createGetDeviceInfoQuery } from 'shared/api';
import { createState } from 'shared/lib';
import { authorizedDeviceRoute } from 'shared/routing';

export type DevicePageTabValues = 'info' | 'players';

const getDeviceInfoQuery = createGetDeviceInfoQuery();

const $device = getDeviceInfoQuery.$data;

const $pending = combine(
	{
		cashdesk: $device,
		pending: getDeviceInfoQuery.$pending,
	},
	({ cashdesk, pending }) => !cashdesk && pending,
);

const currentTabState = createState<DevicePageTabValues>('info');

sample({
	clock: authorizedDeviceRoute.opened,
	fn: ({ params }) => params.id,
	target: getDeviceInfoQuery.start,
});

sample({
	clock: authorizedDeviceRoute.closed,
	target: [getDeviceInfoQuery.reset, currentTabState.$value.reinit],
});

export const devicePageModel = {
	getDeviceInfoQuery,
	currentTabState,
	$pending,
	$device,
};
